import {Slider} from '@ui/forms/slider/slider';
import {FormattedDuration} from '@ui/i18n/formatted-duration';
import {useTrackSeekbar} from '@app/web-player/player-controls/seekbar/use-track-seekbar';
import {Track} from '@app/web-player/tracks/track';
import clsx from 'clsx';
import {usePlayerStore} from '@common/player/hooks/use-player-store';

interface TrackSeekbarProps {
  track: Track;
  queue?: Track[];
  className?: string;
}
export function TrackSeekbar({track, queue, className}: TrackSeekbarProps) {
  const {duration, ...sliderProps} = useTrackSeekbar(track, queue);
  const controlsLocked = usePlayerStore(s => s.controlsLocked);

  return (
    <div className={clsx('flex items-center gap-12', className)}>
      <div className="min-w-40 flex-shrink-0 text-right text-xs text-muted">
        {sliderProps.value ? (
          <FormattedDuration seconds={sliderProps.value} />
        ) : (
          '0:00'
        )}
      </div>
      <Slider
        trackColor="neutral"
        thumbSize="w-14 h-14"
        showThumbOnHoverOnly={true}
        className="flex-auto"
        width="w-auto"
        isDisabled={controlsLocked}
        {...sliderProps}
      />
      <div className="min-w-40 flex-shrink-0 text-xs text-muted">
        {duration !== Infinity ? (
          <FormattedDuration
            seconds={duration}
            addZeroToFirstUnit={duration >= 600}
          />
        ) : (
          <>--:--</>
        )}
      </div>
    </div>
  );
}
